<template>
  <b-row>
    <b-col cols="12">
      <div class="d-flex align-items-center">
        <b-button to="/settings" variant="outline" class="text-primary">
          <feather-icon icon="ArrowLeftIcon" /> Back to Settings
        </b-button>
        <div>
          <h3 class="font-weight-bolder mb-0">System Configuration</h3>
          <p class="text-muted mb-0">
            Configure general system settings and platform preferences
          </p>
        </div>
      </div>
    </b-col>
    <b-col cols="12" class="mt-2">
      <b-tabs pills active-nav-item-class="active">
        <b-tab title="General" active>
          <template #title>
            <feather-icon icon="SettingsIcon" /> <strong>Display Settings</strong>
          </template>
          <General />
        </b-tab>
        <b-tab title="API Config">
          <template #title>
            <feather-icon icon="WifiIcon" /> <strong>API Config</strong>
          </template>
          <APIConfig />
        </b-tab>
        <b-tab title="Platform">
          <template #title>
            <feather-icon icon="GlobeIcon" /> <strong>Platform</strong>
          </template>
          <Platform />
        </b-tab>
        <b-tab title="System Status">
          <template #title>
            <feather-icon icon="MonitorIcon" /> <strong>System Status</strong>
          </template>
          <Performance />
        </b-tab>
        <b-tab title="Maintenance">
          <template #title>
            <feather-icon icon="ServerIcon" /> <strong>Maintenance</strong>
          </template>
          <Maintenance />
        </b-tab>
        <b-tab title="Marketing & Promo">
          <template #title>
            <feather-icon icon="GiftIcon" /> <strong>Marketing &amp; Promo</strong>
          </template>
          <MarketingPromo />
        </b-tab>
        <b-tab title="General Settings">
          <template #title>
            <feather-icon icon="SlidersIcon" /> <strong>General Settings</strong>
          </template>
          <GeneralSettings />
        </b-tab>
      </b-tabs>
    </b-col>
  </b-row>
</template>

<script>
import {
  BCard,
  BForm,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BFormCheckbox,
  BTab,
  BTabs,
} from "bootstrap-vue";
import General from "./General.vue";
import APIConfig from "./APIConfig.vue";
import Platform from "./Platform.vue";
import Performance from "./Performance.vue";
import Maintenance from "./Maintenance.vue";
import MarketingPromo from "./MarketingPromo.vue";
import GeneralSettings from "./GeneralSettings.vue";

export default {
  components: {
    BCard,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BFormCheckbox,
    BTab,
    BTabs,
    General,
    APIConfig,
    Platform,
    Performance,
    Maintenance,
    MarketingPromo,
    GeneralSettings,
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss">
.nav-pills {
  border-bottom: 1px solid #e5e7eb;
  background: #ececf0;
  border-radius: 12px;
  padding: 5px;
  width: 100%;
  .nav-item {
    flex-grow: 1;
  }
}
.nav-pills .nav-link {
  border-radius: 12px;
  color: black;
  background: transparent;
  padding: 8px;
  transition: all 0.2s ease;
  border: none;
}
.nav-pills .nav-link.active {
  background: white !important;
  color: black !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
</style>
